import React, { useState, useCallback } from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
  Typography,
  Button,
} from '@material-ui/core';
import { t } from 'ttag';
import clsx from 'clsx';
import { useStoreActions } from '../../models/RootStore';
import { Confirmation2FADialogStyles } from './Confirmation2FADialog.style';



const Confirmation2FADialog = ({ onCancel }) => {
  const classes = Confirmation2FADialogStyles();

  const verify2FA = useStoreActions((actions) => actions.users.verify2FA);

  const [inputValue, setInputValue] = useState('');
  const [errorText, setErrorText] = useState('');

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  }

  const handleTwoFactorVerification = useCallback(
    (verificationCode) => async () => {
      // Clear previous 2FA errors
      setErrorText('');

      try {
        await verify2FA(verificationCode);
        // Success - dialog will close automatically
      } catch (error) {
        // Set 2FA error message
        if (error?.message) {
          setErrorText(
            t`The code you entered is invalid or expired. Please check again you entered the right code, or try logging in again to receive a new code.`
          );
        } else {
          setErrorText(t`Something went wrong please try again later.`);
        }
      }
    }, [verify2FA]);

  return (
    <Dialog
      open
      onClose={onCancel}
      classes={{ paper: classes.dialogStyle }}
    >
      <DialogTitle
        disableTypography
        className={classes.dialogTitle}
      >
        {t`Additional authentication required`}
      </DialogTitle>

      <DialogContent classes={{ root: classes.dialogContentStyle }}>
        <DialogContentText className={classes.contentStyle}>
          {t`Your account requires an additional authentication code that was sent to your email address. Please enter the code below`}
        </DialogContentText>
        <TextField
          className={classes.input}
          id="2FAcode"
          label="Code"
          value={inputValue}
          onChange={handleInputChange}
        />
        {errorText &&
          <Typography className={classes.errorTextStyle}> {errorText} </Typography>
        }
      </DialogContent>

      <DialogActions
        className={classes.dialogActionStyle}
        classes={{ spacing: classes.actionsSpacing }}
      >
        <Button
          onClick={onCancel}
          className={clsx(classes.sharedButtonStyle, classes.cancelButtonStyle)}
        >
          {t`Cancel`}
        </Button>
        <Button
          onClick={handleTwoFactorVerification(inputValue)}
          disabled={!inputValue}
          className={clsx(classes.sharedButtonStyle, classes.confirmButtonStyle)}
        >
          {t`Submit`}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default Confirmation2FADialog;
